// src/reducers/slices/RequestIdSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RequestIdState {
  requestId: string | null;
}

const initialState: RequestIdState = {
  requestId: null,
};

const requestIdSlice = createSlice({
  name: "requestId",
  initialState,
  reducers: {
    setRequestId: (state, action: PayloadAction<string>) => {
      state.requestId = action.payload;
    },
    clearRequestId: (state) => {
      state.requestId = null;
    },
  },
});

export const { setRequestId, clearRequestId } = requestIdSlice.actions;
export default requestIdSlice.reducer;